<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{pageTitle}}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- //breadcrumbs -->

            <fragment v-if="mode === MODE.SEARCH">
                <div class="srchTop_wrap srch_result">
                    <article class="srch_basic clear">
                        <dl class="dl_search w100p">
                            <dd class="" data-input-type="input">
                                <span class="clearable">
                                    <input
                                        ref="modelCode"
                                        type="text"
                                        class="text_input w100p"
                                        placeholder="Enter a model code"
                                        minlength="4"
                                        maxlength="100"
                                        @keyup.enter.stop="search(1)"
                                        v-validation
                                        v-clearable
                                    />
                                </span>
                            </dd>
                            <dd class="btn">
                                <a href="javascript:" class="btn_srch" @click="search(1)">
                                    {{ $t('FIELD.GLOBAL.SEARCH') }}
                                </a>
                            </dd>
                        </dl>
                    </article>
                </div>

                <div v-if="gridColumns.length > 0">
                    <!-- Grid -->
                    <div class="grid_wrap">
                        <!-- Grid Count-->
                        <div class="grid_total">
                            Total Count
                            <em>{{ resultCount | numberFormat }}</em>
                        </div>
                        <!-- Grid "btn-->
                        <div id="grid">
                            <toast-grid
                                gridId="gridCms"
                                :key="gridKey"
                                :data="gridData"
                                :columns="gridColumns"
                                :header="gridHeader"
                                :options="gridOptions"
                                :pageOptions="gridPageOptions"
                                :theme="gridTheme"
                                :isTotalCount="false"
                                v-bind:click="onGridCellClick"
                            />
                        </div>
                    </div>
                    <div class="paginate">
                        <sdl-pagination
                            :current-page="currentPage"
                            :total-rows="resultCount"
                            :per-page="perPage"
                            @change="search"
                            align="center"
                        />
                    </div>
                </div>

                <div style="margin-top: 80px; min-height: 400px;">
                    <cms-model-search
                        v-if="gubun !== ''"
                        :key="gubun+model"
                        :gubun="gubun"
                        :model="model"
                        v-on:select-model="onSelectModel"
                    />
                </div>

            </fragment>

            <fragment v-else-if="mode === MODE.VIEW">
                <cms-detail
                    :cttid="cttid"
                    :prodType="prodType"
                    :prodSubType="prodSubType"
                    v-on:back-to-list="onBackToList" />
            </fragment>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

import $ from 'jquery';
import qs from 'query-string';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import { SDLUtil, DateUtil } from '@/utils';

import ToastGrid from '~c/ToastGrid';
import Pagination from '@/components/common/control/pagination/Pagination';

import { CellHtmlRenderer, HeaderHtmlRenderer, } from '~c/GridCustomRenderer';

import CmsModelSearch from './CmsModelSearch';
import CmsDetail from './CmsDetail';

const MODE = {
    SEARCH: 'search',
    VIEW: 'view',
};

export default {
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,

        'cms-model-search': CmsModelSearch,
        'cms-detail': CmsDetail,
    },
    data() {
        return {
            MODE,

            pageTitle: '',

            mode: MODE.SEARCH,

            modelCode: '',

            gubun: '', // selected model's gubun
            model: '', // selected model

            cttid: '',

            resultCount: 0,
            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 20),

            gridHeader: [],

            gridColumns: [],
            gridData: [],

            gridOptions: {
                scrollX: true,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                },
            },
        };
    },

    computed: {
        ...mapGetters({
            params: 'getParams',
        }),
    },
    created() {
        this.initLoad();
    },
    mounted() {
    },
    methods: {
        initLoad() {
            const path = '/basis/common/cmsContents/cmsByModelcode.skp';
            const formData = {
                menuId: this.params.menuId,
            };
            return SDLUtil.postForm(path, formData);
        },

        async search(pageNo) {

            this.modelCode = this.$refs.modelCode.value;
            if (!this.validateForm()) return;

            const path = '/basis/common/cmsContents/cmsListSearch.skp?searchInfo=set';
            const formData = {
                menuId: this.params.menuId,
                page: pageNo || 1,
                inputModelCode: this.modelCode,
                ORDER_ASC: 'ASC',
                ORDER_FLAG: 'N',
            };

            SDLUtil.showLoadingBar(true);
            const data = await SDLUtil.postForm(path, formData);
            SDLUtil.showLoadingBar(false);

            if (data.list.length < 20) {
                data.count = data.list.length;
            }

            this.resultCount = data.count;
            this.setGridHeader(data.header);
            this.setGridData(data.list);

            this.currentPage = pageNo;

            this.gridKey += 1;

            this.clearModelSearch();
        },

        clearModelSearch() {
            const gubun = '';
            const model = '';
            this.updateModelSearchProps(gubun, model);
        },

        setGridData(list) {
            list.map(item => {
                for (let key in item) {
                    if (item[key] === 'Y') {
                        item[key] = '<span style="cursor: pointer; color: blue;">Y</span>';
                    }
                }
                return item;
            });
            this.gridData = list;
        },

        validateForm() {
            if (this.modelCode.length < 4) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please enter 4 or more characters for Model Code.',
                });
                return false;
            }
            return true;
        },

        setGridHeader(header) {
            this.gridHeader = {
                columns: header.map(item => {
                    return {
                        name: item.CONTENTS_CD,
                        renderer: HeaderHtmlRenderer,
                    };
                }),
            };

            const fixedColumns = [
                {
                    header: 'No.',
                    name: 'RNUM',
                    width: 60,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Model',
                    name: 'NMMODEL',
                    width: 150,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Model Code',
                    name: 'CDMODEL',
                    width: 150,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ];

            this.gridColumns = [
                ...fixedColumns,
                ...header.map(item => {
                    let width = 110;
                    // if (item.CONTENTS_DESC === 'Subject') {
                    //     width = null; // Free Size
                    // }
                    return {
                        header: item.CONTENTS_DESC,
                        name: item.CONTENTS_CD,
                        width,
                        align: 'center',

                        renderer: CellHtmlRenderer,
                        resizable: false,
                        sortable: false,
                    }; }
                ),
            ];

        },

        onGridCellClick(event, rowData) {
            console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            console.log('event row', rowData[event.rowKey]);

            if (row[event.columnName].length > 0) {
                window.scrollTo({
                    top: 5000, 
                    left: 0,
                    behavior: 'smooth',
                });
                const gubun = event.columnName;
                const model = row.CDMODEL;
                this.updateModelSearchProps(gubun, model);
            }
        },

        updateModelSearchProps(gubun, model) {
            this.gubun = gubun;
            this.model = model;
        },

        onSelectModel(event) {
            this.cttid = String(event.CTTID);
            this.prodType = event.nmProdType;
            this.prodSubType = event.nmProdSubType;

            this.switchMode(MODE.VIEW);
        },

        onBackToList(event) {
            this.switchMode(MODE.SEARCH);

            window.setTimeout(() => {
                window.scrollTo({
                    top: 5000, 
                    left: 0,
                });
            }, 500);
        },

        switchMode(mode) {
            this.mode = mode;
        },
    },
}
</script>

<style >

</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/cmsContents/CmsByModelCode.vue